export default __webpack_public_path__ + "static/RomainPrevedello-8c749da0295e48a62cdece54de699fcb.png";